var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivilegedIdentitiesStatsSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "0ha2tug3aa",
    d: "M0 0h18.258v21H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.502 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ffun8fq5wb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0ha2tug3aa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.917 13.146a1.256 1.256 0 1 1 0-2.512 1.256 1.256 0 0 1 0 2.512M9.15 19.914a1.256 1.256 0 1 1 0-2.511 1.256 1.256 0 0 1 0 2.511M6.432 4.47a2.784 2.784 0 1 1 5.568 0 2.784 2.784 0 0 1-5.568 0m-4.09 8.676a1.256 1.256 0 1 1 0-2.512 1.256 1.256 0 0 1 0 2.512m13.575-3.598a2.342 2.342 0 0 0-2.172 3.216l-3.721 3.721a2.356 2.356 0 0 0-.044-.017V8.874A4.47 4.47 0 0 0 9.216 0a4.47 4.47 0 0 0-.904 8.848h-.078v7.654l-.013.006-3.718-3.718a2.342 2.342 0 1 0-1.223 1.246l3.712 3.712a2.341 2.341 0 1 0 4.292-.054l3.67-3.67a2.341 2.341 0 1 0 .964-4.476",
    fill: "#804998",
    mask: "url(#ffun8fq5wb)"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    fill: "#804998",
    d: "M15.544 7.738 14.31 8.973l3.125 3.126 1.235-1.235zM6.594 10.915l1.234 1.235 3.235-3.236L9.829 7.68z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilegedIdentitiesStatsSection);
export default __webpack_public_path__ + "static/media/privileged-identities-stats-section.904a55f1801f67759df8abffb2ca1487.svg";
export { ForwardRef as ReactComponent };